/*************************
  Type concerns for spaces.
  Expects to be used from the client side, also.
  *********************************************/

import { InferAttributes } from "sequelize";
import { ItemType } from "src/components/useLibrary";
import type { SpaceItem as SequelizeSpaceItem } from "src/models";
type SpaceItem = InferAttributes<SequelizeSpaceItem>;
export type { SpaceItem };

// I'm rebelling.
// Langauge evolves and labels become brittle
// If I store something meaningless, I'll never be misled.
// In the inevitable pivot to a new lexicon, the database won't even notice.

export enum SpaceItemType {
  Board = "8f14c3f9",
  Entity = "8d281bd0",
  Query = "875c0b17",
  Space = "b0b7f492",
}

export function spaceItemType(type: SpaceItemType) {
  return type === SpaceItemType.Board
    ? ItemType.BOARDS
    : type === SpaceItemType.Entity
    ? "entity"
    : type === SpaceItemType.Query
    ? ItemType.BOARDS
    : ItemType.SPACES;
}

export type EntityLinkSpaceItem = SpaceItem & {
  type: SpaceItemType.Entity | SpaceItemType.Space;
  config: {
    entity_uuid: string;
  };
};

export type DeepLinkSpaceItem = SpaceItem & {
  type: SpaceItemType.Board | SpaceItemType.Query;
  config: {
    deep_link_id: string;
  };
};

export function isDeepLinkSpaceItem(
  item?: SpaceItem
): item is DeepLinkSpaceItem {
  return (
    item !== undefined &&
    [SpaceItemType.Board, SpaceItemType.Query].includes(item.type)
  );
}

export function isEntityLinkSpaceItem(
  item?: SpaceItem
): item is EntityLinkSpaceItem {
  return (
    item !== undefined &&
    [SpaceItemType.Entity, SpaceItemType.Space].includes(item.type)
  );
}

export function isEntitySpaceItem(
  item?: SpaceItem
): item is EntityLinkSpaceItem & { type: SpaceItemType.Entity } {
  return isEntityLinkSpaceItem(item) && item.type === SpaceItemType.Entity;
}

export function isSpaceSpaceItem(
  item?: SpaceItem
): item is EntityLinkSpaceItem & { type: SpaceItemType.Space } {
  return isEntityLinkSpaceItem(item) && item.type === SpaceItemType.Space;
}

export function isBoardSpaceItem(
  item?: SpaceItem
): item is DeepLinkSpaceItem & { type: SpaceItemType.Board } {
  return isDeepLinkSpaceItem(item) && item.type === SpaceItemType.Board;
}

export function isQuestionSpaceItem(
  item?: SpaceItem
): item is DeepLinkSpaceItem & { type: SpaceItemType.Query } {
  return isDeepLinkSpaceItem(item) && item.type === SpaceItemType.Query;
}
